export default function ColumnHeader({ title, subtitle, onClose, children }) {

  return (
    <div>
      <div className={"d-flex align-items-baseline pt-3"}>
        <h4 className={"align-items-baseline"}>
          {title}
        </h4>
        {subtitle &&
          <h5 className={"text-muted ps-2"}>
            {subtitle}
          </h5>}
        <div className="flex-grow-1" />
        <div>
          {children}
        </div>
        {onClose &&
          <button onClick={onClose}
            className={"btn btn-close btn-small p-0 m-0"} />}
      </div>
      <hr />
    </div>)

}